import { GEAR_SLOTS, qualitySchema } from '@wyn/content';
import { z } from 'zod';

/** Fight shapes shared by the player snapshot, the event log and the fight routes. */
export const attackSlotSchema = z.enum(['mainHand', 'offHand', 'ranged', 'fists']);
export const fightChoiceSchema = z.enum(['spare', 'rob', 'maim']);
export const gearSlotSchema = z.enum(GEAR_SLOTS);
export const loadoutSchema = z.partialRecord(gearSlotSchema, z.object({ itemKey: z.string(), quality: qualitySchema }));
export type LoadoutView = z.infer<typeof loadoutSchema>;

export const strikeSchema = z.object({
  by: z.enum(['attacker', 'defender']),
  slot: attackSlotSchema,
  weapon: z.string(),
  hit: z.boolean(),
  damage: z.number().int(),
  lifeAfter: z.number(),
});
export const fightTurnSchema = z.object({ turn: z.number().int(), strikes: z.array(strikeSchema) });
export type FightTurnView = z.infer<typeof fightTurnSchema>;

export const fightResultSchema = z.enum(['won', 'lost', 'stalemate', 'withdrew']);
/** The turn-by-turn report written to both players' event logs. */
export const fightReportSchema = z.object({
  fightId: z.string(),
  attacker: z.string(),
  defender: z.string(),
  result: fightResultSchema,
  choice: fightChoiceSchema.nullable(),
  turns: z.array(fightTurnSchema),
});
export type FightReport = z.infer<typeof fightReportSchema>;
